$(document).ready(function($) {

  $('.form-intFilter').on('click', '.custom-control-input', function() {
    let category = $(this).data('category');

    if (category === 'all') {
      if ($(this).prop('checked')) {
        toggleCheckAll(true);
        showAll();
      } else {
        toggleCheckAll(false);
        hideAll();
      }
      return;
    } else {
      $('.form-intFilter .custom-control-input[data-category="all"]').prop('checked', false);
    }

    let checkboxesChecked = document.querySelectorAll('.form-intFilter .custom-control-input:checked');
    if (!checkboxesChecked.length) {
      restoreInitialState();
      return;
    }
    let categoriesToShow = [];

    // show/hide the Upcoming header based on # tiles that will be displayed
    let numUpcoming = 0;
    checkboxesChecked.forEach(function(ch) {
      categoriesToShow.push(ch.dataset.category);
      numUpcoming += $('.grid-int__item[data-state][data-category*='+ch.dataset.category+']').length;
    });
    if (numUpcoming) {
      $('#upcomingHeader').show();
    } else {
      $('#upcomingHeader').hide(300);
    }

    function shouldBeShown(cat) {
      return categoriesToShow.includes(cat);
    }

    $('.grid-int__item').each(function() {
      let intCategories = $(this)
              .data('category')
              .split(',');
      if (intCategories.some(shouldBeShown)) {
        $(this).show();
      } else {
        $(this).hide(300);
      }
    });
  });

});

function restoreInitialState()
{
  $('.form-intFilter .custom-control-input[data-category="all"]').prop('checked', true);
  showAll();
}

function toggleCheckAll(setChecked)
{
  $('.form-intFilter .custom-control-input').prop('checked', setChecked);
}

function showAll()
{
  $('.grid-int__item').show();
}

function hideAll()
{
  $('.grid-int__item').hide();
}